import React, {
  useEffect,
  useCallback,
  Suspense,
  lazy,
} from "react";

import "../Manage Projects/viewProjects.css";
import "./viewNews.css";

import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";

import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

import { viewNews } from "../../Redux/Actions/newsAction";

const SearchBar = lazy(() => import("../Main/searchBar"));
const NewsContent = lazy(() => import("./newsContent"));

const ViewNews = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { news, loading } = useSelector((state) => state.news);
  const data = news?.data;

  useEffect(() => {
    if (!id) return;
    if (news?.data?._id === id) return;

    dispatch(viewNews(id)).catch(() => {
      toast.error("Failed to load news details.");
    });
  }, [id, dispatch, news]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "Not specified";

    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }, []);

  if (loading) {
    return (
      <div className="loading-wrapper">
        <div className="loading-content">
          <div className="spinner"></div>
          <p className="loading-text">Loading news details...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="padding-20 gap-10 grid-container"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
        background: "#F5F7FA",
      }}
    >

      <div style={{ gridColumn: "3/8" }}>
        <Suspense fallback={null}>
          <SearchBar style={{ width: "max-content" }} />
        </Suspense>
      </div>

      <div className="header-section">
        <Link to="/news_and_articles">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>

        <div className="title-wrapper">
          <h1>News Details</h1>
          <p>News / List / View</p>
        </div>
      </div>

      <Suspense
        fallback={
          <div className="main-content">
            <p className="loading-text">Loading content...</p>
          </div>
        }
      >
        {data && (
          <NewsContent
            data={data}
            formatDate={formatDate}
          />
        )}
      </Suspense>
    </div>
  );
};

export default ViewNews;
